import React, { useRef } from "react";
import Barcode from "react-barcode";
import CuModal from "../../common_component/component/CuModal";

const BarcodeModal = ({ items, onClose }) => {
  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current;
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Barcodes</title>
          <style>
            @page { margin: 0; size: auto; }
            body { margin: 0; padding: 0; display: flex; flex-wrap: wrap; }
            .barcode-container { 
              width: calc(33.33% - 10mm); 
              margin: 5mm; 
              display: flex; 
              flex-direction: column; 
              align-items: center; 
              justify-content: center; 
              text-align: center; 
            }
            .barcode-name { 
              font-size: 12px; 
              margin-bottom: 5px; 
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  if (!items || items.length === 0) {
    return (
      <CuModal className="w-[40%]">
        <div className="bg-white rounded-lg p-6">
          <h2 className="text-red-500 text-lg">No Items Available</h2>
          <button
            onClick={onClose}
            className="mt-4 bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </CuModal>
    );
  }

  return (
    <CuModal className="w-[80%]">
      <div className="bg-white rounded-lg p-1">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-700">
            Print Barcodes
          </h2>
          <button
            onClick={onClose}
            className="text-red-600 hover:text-red-800 font-bold"
          >
            X
          </button>
        </div>

        {/* Modal Content */}
        <div
          ref={printRef}
          className="flex flex-wrap overflow-y-auto max-h-96"
          style={{ justifyContent: "flex-start" }}
        >
          {items.map((item, index) => (
            <div
              key={index}
              className="barcode-container"
              style={{
                width: "calc(33.33% - 10mm)",
                margin: "5mm",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span className="barcode-name">{item.generalInfo?.itemName}</span>
              <Barcode value={item.generalInfo?.itemId} />
            </div>
          ))}
        </div>

        {/* Print Button */}
        <div className="flex justify-end mt-4">
          <button
            onClick={handlePrint}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 mr-2"
          >
            Print Barcodes
          </button>
          <button
            onClick={onClose}
            className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </CuModal>
  );
};

export default BarcodeModal;
